export default __webpack_public_path__ + "static/word-deluxe-0040dea592911f56ddefae523cc46481.svg";